
export const ExamsScreen = () => `
        <div id="exams-screen" class="screen">
            <button class="back-btn-custom" onclick="window.Router.showScreen('category-screen')">
                ← GERİ
            </button>
            <div class="exams-header">
                <h2 class="exams-title">SINAVLAR</h2>
                <p class="exams-subtitle">Hazırlık Sürecinde Yanınızda</p>
            </div>
            
            <div class="exams-grid">
                <!-- LGS -->
                <div class="exam-card" onclick="window.utils.showToast('LGS Modülü çok yakında yayında!')">
                    <span class="exam-icon">🎓</span>
                    <div class="exam-info">
                        <span class="exam-name">LGS</span>
                        <span class="exam-desc">Liselere Geçiş Sistemi</span>
                    </div>
                </div>

                <!-- YKS -->
                <div class="exam-card" onclick="window.utils.showToast('YKS Modülü hazırlık aşamasında.')">
                    <span class="exam-icon">📚</span>
                    <div class="exam-info">
                        <span class="exam-name">YKS</span>
                        <span class="exam-desc">Yükseköğretim Kurumları Sınavı</span>
                    </div>
                    <span class="coming-soon-badge">YAKINDA</span>
                </div>

                <!-- EKPSS/KPSS -->
                <div class="exam-card" onclick="window.utils.showToast('KPSS/EKPSS Modülü çok yakında!')">
                    <span class="exam-icon">🏛️</span>
                    <div class="exam-info">
                        <span class="exam-name">EKPSS</span>
                        <span class="exam-desc">Engelli Kamu Personeli Sınavı</span>
                    </div>
                </div>
            </div>
        </div>
`;
